import askGithub from './askGithub'

/**
 * Gets the details of a branch and the repository it belongs to when given
 * a branch id
 * @param {string} authToken
 * @param {string} branchId
 * @return {Promise<object>}
 */
async function getBranchAndRepositoryDetails(authToken, branchId){
  if (!authToken)
    throw new Error(`Invalid 'authToken' ${authToken}.`)
  if (!branchId)
    throw new Error(`Invalid 'branchId' ${branchId}.`)
  // Grab the repoid
  var result = await askGithub(authToken, `query{
    node(id:"${branchId}"){
      ...on Ref {
        name
        repository {
          id
          name
          owner {
            login
          }
        }
      }
    }
  }`)

  return {
    repositoryId: result['data']['node']['repository']['id'],
    repositoryOwner: result['data']['node']['repository']['owner']['login'],
    repositoryName: result['data']['node']['repository']['name'],
    branchName: result['data']['node']['name'],
  }

}

export default getBranchAndRepositoryDetails


// WEBPACK FOOTER //
// ./src/lib/getBranchAndRepositoryDetails.js